module.exports = __webpack_public_path__ + "img/Unicom-9.8d9d88f5.svg";